import { SnackbarAlertActionProps } from '@global-engineering-shared/gweb-material-types';
import React, { createContext, useContext, useMemo, useState } from 'react';

import {
  defaultSnackbarContentProps,
  SnackbarContentProps,
} from 'components/SnackbarContent/SnackbarContent';

export interface ISnackbarInfo {
  content: SnackbarContentProps;
  autoHideDuration?: number;
  open: boolean;
  severity?: SnackbarAlertActionProps['severity'];
}

interface ISnackbarContext {
  setSnackbarInfo: React.Dispatch<React.SetStateAction<ISnackbarInfo>>;
  snackbarInfo: ISnackbarInfo;
}

const SnackbarContext = createContext<ISnackbarContext | null>(null);

const SnackbarProvider = ({ children }: { children: React.ReactNode }) => {
  const [snackbarInfo, setSnackbarInfo] = useState<ISnackbarInfo>({
    content: defaultSnackbarContentProps,
    open: false,
    severity: 'success',
  });

  const snackbarContext = useMemo(
    () => ({
      setSnackbarInfo,
      snackbarInfo,
    }),
    [snackbarInfo, setSnackbarInfo]
  );

  return <SnackbarContext.Provider value={snackbarContext}>{children}</SnackbarContext.Provider>;
};

export const useSnackbar = () => {
  const snackbarContext = useContext(SnackbarContext);

  if (!snackbarContext) {
    throw new Error('useSnackbar must be used within SnackbarProvider');
  }
  return snackbarContext;
};

export default SnackbarProvider;
